import Vue from 'vue';
import Router from 'vue-router';
import LinkUser from '@/components/LinkUser';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/my-hospitals/:hospitalId',
      name: 'HospitalAdministration',
      component: LinkUser,
    },
  ],
  mode: 'history',
});



// WEBPACK FOOTER //
// ./src/router/index.js